import React from "react";
import { Route, Redirect } from "react-router-dom";
const authenticationHelper = require('../libs/helpers/authenticationHelper');

export default ({ component: C, props: cProps, ...rest }) =>
  <Route
    {...rest}
    render={props =>
      authenticationHelper.isAuthenticated() && authenticationHelper.isAdminLogged()
        ? <C {...props} {...cProps} />
        : (authenticationHelper.isAuthenticated() ? <Redirect to="/forbidden"/> : <Redirect to="/login"/>)
    }
  />;



// WEBPACK FOOTER //
// ./src/components/AdminAuthenticatedRoute.js